import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/**
 * Starts an approve/export job. Returns fast (the Node worker runs async) -
 * this call only confirms the job was queued, not that it finished. What
 * happens next depends on the caller: approve may still poll getAsset for
 * its result; export's own result now arrives by email instead, so nothing
 * further needs to be watched here for it.
 */
export async function startExportJob(
  appConfig,
  { brandId, assetId, action, motionPreset, asset, identity, references, brand, userEmail },
  setIsLoading,
  setApiResponse
) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "start_export_job",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
    action,
    motion_preset: motionPreset ?? null,
    asset,
    identity,
    references,
    brand,
    user_email: userEmail,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const returnedAsset = response?.data?.asset;
  if (!returnedAsset) {
    throw new Error(response?.data?.error || "Couldn't start this job");
  }
  return returnedAsset;
}